import React, { useCallback, useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';
import * as baseActions from '../modules/base';

import { useShortCut } from "Hook/useShortCut";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";


const ImageViewer = ({attach, callback}) => {

  const dispatch = useDispatch();

  const refPopup = useRef();
  const refImg = useRef();
  const refOriginal = useRef();
  const refMethodTransform = useRef();
  const animationDuration = 420;


  const handleClickClose = useCallback((result) => {
    refPopup.current.classList.remove('active');
    if (callback) {
      setTimeout(() => {
        callback(result);
      }, animationDuration);
    }
  },[callback]);


  useEffect(()=>{
    refPopup.current.classList.add('active');
    refImg.current.onload = function() {
      // console.log('넓이높이',this.naturalWidth, this.naturalHeight)
      const widthScale = this.naturalWidth/window.innerWidth;
      const heightScale = this.naturalHeight/window.innerHeight;
      const scale = widthScale > heightScale ? widthScale : heightScale;
      const offsetX = (scale - 1) * window.innerWidth / (-2);
      const offsetY = (scale - 1) * window.innerHeight / (-2)

      refOriginal.current = {
        scale: scale,
        offsetX: offsetX,
        offsetY: offsetY,
      }

      //패닝 라이브러리 초기화 버그때문에 아래코드 넣어놓음
      if (scale < 1 && refMethodTransform.current) {
        refMethodTransform.current.setTransform(offsetX, offsetY, scale, 20);
      }
      setTimeout(() => {
        refImg.current.style.visibility = '';
      }, 20);

    }
  },[])


  useEffect(()=>{
    dispatch(baseActions.addPopupCnt());
    return () => {
      dispatch(baseActions.subPopupCnt());
    }
  },[dispatch]);


  const handleShortCut = useCallback(key => {
    switch(key) {
      case 'Escape':
        handleClickClose(false);
        break;
      default:
    }
  },[handleClickClose]);

  useShortCut(handleShortCut);
  

  return (
    <div className="imgViewer" ref={refPopup}>
      <div className="inner">
        <TransformWrapper 
          options={{minScale: 0.1, limitToBounds: false, limitToWrapper: false}}
          wheel={{step: 300}}
        >
          {({ zoomIn, zoomOut, resetTransform, setTransform }) => {
            refMethodTransform.current = {
              setTransform: setTransform,
            }
            const setOriginal = () => {
              if (!refOriginal.current) {
                return;
              }
              setTransform(refOriginal.current.offsetX, refOriginal.current.offsetY, refOriginal.current.scale)
            }

            return (
              <>
                <TransformComponent>
                  <figure>
                    <img ref={refImg} style={{width: '100vw', height: '100vh', objectFit: 'contain', visibility:'hidden' }} src={`${process.env.REACT_APP_FILE_API_URL}?type=1&serverfile=${attach.save_file}`} alt={attach.org_file} />
                  </figure>
                </TransformComponent> 

                <div className="ctrBtn">
                  <button type="button" className="ctr default" onClick={setOriginal}>원본</button>
                  <button type="button" className="ctr fit" onClick={resetTransform}>화면맞춤</button>
                  <button type="button" className="ctr small" onClick={zoomOut}>작게</button>
                  <button type="button" className="ctr big" onClick={zoomIn}>크게</button>
                </div>
                <button type="button" className="close" onClick={handleClickClose.bind(this, false)}>닫기</button>
              </>
            )}
          }
        </TransformWrapper>
      </div>
    </div>
  )
}

export default ImageViewer;